/**
 * Error handler registry for ConfirmDialog's onAction callback.
 *
 * @packages/ui cannot import from @packages/shared (circular dependency via Toast),
 * so we use the same registry pattern as @packages/api-client/globalErrorHandler.
 * The app shell registers the handler once at startup.
 */

type ErrorHandler = (error: unknown) => void;

let registeredHandler: ErrorHandler | null = null;

export function registerConfirmErrorHandler(handler: ErrorHandler): void {
  registeredHandler = handler;
}

export function handleConfirmError(error: unknown): void {
  registeredHandler?.(error);
}
